import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaWhatsapp } from 'react-icons/fa';

const products = [
  'Pool Pumps',
  'Pool Cleaners',
  'Pool Lights',
  'Pool Filters',
  'Chlorinators',
  'Chemicals',
];

const DetailsSection = () => {
  useEffect(() => {
    AOS.init({ once: false, mirror: true });
  }, []);

  return (
    <section id="details" className="bg-gray-50 py-20 px-4 sm:px-8 lg:px-20">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div
          className="text-center mb-10"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <span className="inline-block text-xs font-semibold tracking-widest text-primary uppercase mb-3">
            What We Offer
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-tertiary mb-4">
            Everything Your Pool Needs, All in One Place
          </h2>
          <p className="max-w-2xl mx-auto text-gray-600 leading-relaxed">
            At Pool Shop Surya Jaya Teknik in Ubud, Bali, we stock trusted
            brands and provide expert advice for villa, guesthouse, and resort
            pools across Bali.
          </p>
        </div>

        {/* Product tags */}
        <div
          className="flex flex-wrap justify-center gap-3 mb-10"
          data-aos="fade-up"
          data-aos-duration="900"
        >
          {products.map((name, i) => (
            <span
              key={i}
              className="bg-white border border-primary/30 text-tertiary font-semibold text-sm px-5 py-2 rounded-full shadow-sm"
            >
              {name}
            </span>
          ))}
        </div>

        {/* Intro paragraph */}
        <p
          className="text-center text-gray-600 leading-relaxed mb-10 max-w-2xl mx-auto"
          data-aos="fade-up"
          data-aos-duration="900"
        >
          Located on Jalan Raya Andong, Ubud, our team covers you no matter
          where in Bali you are. From in-store purchases to on-site service
          calls, we make pool ownership stress-free.
        </p>

        {/* CTA */}
        <div
          className="bg-primary rounded-2xl px-6 py-8 sm:px-10 flex flex-col sm:flex-row items-center justify-between gap-6 text-center sm:text-left"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <div>
            <p className="text-tertiary font-bold text-lg mb-1">
              Not sure what your pool needs?
            </p>
            <p className="text-tertiary/70 text-sm">
              Chat with us on WhatsApp and we will help you find the right
              product.
            </p>
          </div>
          <a
            href="https://wa.me/628123618911"
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 inline-flex items-center gap-2 bg-tertiary hover:opacity-90 text-white font-semibold px-6 py-3 rounded-full transition text-sm sm:text-base shadow-md"
          >
            We are partners. Chat via WhatsApp
            <span>
              <FaWhatsapp size={20} />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default DetailsSection;
